//import Vue from 'vue'

//<li><a :href="urls.links.F35NPM" target="_blank" ref="noopener" @click="$_gaPush('F-35NPM series - GALLERYページ - F-35NPM')">F-35NPM</a></li>
//<router-link v-if="urls.page" :to="urls.page.top" @click.native="$_gaPush('ヘッダー - TOP')">

const GAPlugin = {
  install (Vue, options) {
    Vue.prototype.$_gaPush = (id) => {
      ga('send', 'event', '', 'click', id);
      //console.log(id);
    };
  }
}

export default GAPlugin